import React from "react";

import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";

import { useSmartKeysMenu } from "../../../hooks/useSmartKeysMenu";
import { SmartKeyMenu } from "../../shared/SmartKeyMenu";

const SMS_MAX_LENGTH = 320;

type SmsInputWithSmartKeysProps = {
  smsContent: string;
  handleSmsContentChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  availableVariables: string[];
};

function SmsInputWithSmartKeys(props: SmsInputWithSmartKeysProps) {
  const { smsContent, handleSmsContentChange, availableVariables } = props;

  // hooks
  const {
    menuProps,
    buttonProps,
    handleCopyToClipboard,
    notificationVariables,
    loading,
  } = useSmartKeysMenu({
    availableVariables,
  });

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <Button {...buttonProps} id="basic-button">
          <Box minHeight="28px" display="flex" alignItems="center">
            {loading ? <CircularProgress size={16} /> : "+ Smart Keys"}
          </Box>
        </Button>
      </Box>

      <SmartKeyMenu
        {...menuProps}
        notificationVariables={notificationVariables}
        onCopyToClipboard={handleCopyToClipboard}
        helpText="Add smart keys to your templates to add personalized details to the notifications you send out. To use them, just copy and paste them into your template."
      />

      {/* SMS Customized Content */}
      <Box mb={2}>
        <Typography variant="h4">SMS Template</Typography>
      </Box>
      <TextField
        multiline
        rows={6}
        fullWidth
        variant="outlined"
        value={smsContent}
        onChange={handleSmsContentChange}
        inputProps={{
          maxLength: SMS_MAX_LENGTH,
        }}
        // Display character count as helper text
        helperText={`${smsContent.length}/${SMS_MAX_LENGTH} characters`}
      />
    </>
  );
}

export default SmsInputWithSmartKeys;
